<template>
  <div class="input-wrapper input-wrapper-textarea">
    <label v-if="label" :for="name" v-text="label" />
    <textarea
      v-bind="props"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <div
      v-if="maxlength"
      class="counter"
      :class="{ max: modelValue?.length === maxlength }"
    >
      {{ modelValue?.length || 0 }} / {{ maxlength }}
    </div>
  </div>
</template>

<script setup>
defineEmits(["update:modelValue"]);

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  placeholder: {
    type: String,
  },
  rows: {
    type: String,
    default: "5",
  },
  modelValue: {
    type: [String, null],
  },
  maxlength: {
    type: Number,
  },
  disabled: {
    type: Boolean,
  },
});
</script>
